import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import Avatar from '@material-ui/core/Avatar';
import CssBaseline from '@material-ui/core/CssBaseline';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { useAuthState, Loading, useRedirect, useNotify } from 'react-admin';
import * as Auth from '../../api';
import PasswordResetForm from './form';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(10),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  label: {
    cursor: 'pointer',
    fontSize: 14,
  },
}));

const PasswordReset = (props) => {
  const classes = useStyles();
  const { loading, authenticated } = useAuthState();
  const redirect = useRedirect();
  const notify = useNotify();

  const { token } = props.match.params;

  const [submitErrors, setSubmitErrors] = useState([]);
  const [tokenIsValid, setTokenIsValid] = useState(true);

  const onFormSubmit = async (data) => {
    try {
      await Auth.passwordReset(token, data);
      notify('Password was successfully reset. Please login');
      redirect('/login');
    } catch (e) {
      const { errors } = e.response.data;
      setSubmitErrors(errors);
    }
  };

  useEffect(() => {
    const checkPasswordResetToken = async () => {
      try {
        await Auth.checkPasswordResetToken(token);
      } catch (e) {
        setTokenIsValid(false);
      }
    };
    checkPasswordResetToken();
  }, [token]);

  if (loading) {
    return <Loading />;
  }
  if (authenticated || !tokenIsValid) {
    redirect('/');
    return null;
  }
  return (
    <Container component="main" maxWidth="md">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Reset password
        </Typography>
        <PasswordResetForm onSubmit={onFormSubmit} classes={classes} submitErrors={submitErrors} />
      </div>
    </Container>
  );
};

export default withRouter(PasswordReset);
